import React, {
  useEffect,
  useState,
  useRef,
} from "react";
import { Dropdown, DropdownMenu } from "reactstrap";
import { DropdownItem, DropdownToggle } from "./style";
import { Icon } from "../common/style";
import ConfirmationModal from "./ConfirmationModal";
import { cloneItems, cloneRoom } from "./service";

const ProjectDropDown = ({
  isOpen,
  toggle,
  toggleModal,
  id,
  roomId,
  groupId,
  bgcolor,
  onDelete,
  text,
  toggleAddModal,
  isOrderFinalised,
  loadRoom,
  projectSummary,
  selectionManager,
}) => {
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [cloneConfirmationOpen, setCloneConfirmationOpen] = useState(false);
  const isOrderFinalisedRef = useRef(isOrderFinalised);

  useEffect(() => {
    isOrderFinalisedRef.current = isOrderFinalised;
  }, [isOrderFinalised]);

  const toggleDeleteConfirmationState = () => {
    setDeleteConfirmationOpen((prevState) => !prevState);
  };

  const toggleCloneConfirmationState = () => {
    setCloneConfirmationOpen((prevState) => !prevState);
  };

  const doCloneRoom = () => {
    if (isOrderFinalisedRef.current) return;

    return cloneRoom({
      projectId: id,
      roomId: roomId,
    })
      .then((response) => {
        let cloned_room_id = response.id;
        let cloned_room_name = response.name;

        projectSummary.rooms.push({
          id: cloned_room_id,
          name: cloned_room_name,
        });
        loadRoom(cloned_room_id);
        selectionManager.clear();
      })
      .catch(({ error }) => {});
  };

  return (
    <div
      className="d-flex show-on-hover"
      style={{ ...(bgcolor == "white" && { paddingBottom: "3px" }) }}
    >
      <Dropdown isOpen={isOpen} toggle={toggle}>
        <DropdownToggle
          bgcolor={bgcolor}
          className="p-1 ps-2 pe-2 border-0 text-dark"
        >
          <i className={`fa-solid fa-ellipsis-vertical`}></i>
        </DropdownToggle>
        <DropdownMenu className="p-0">
          {text == "Room" && (
            <DropdownItem onClick={toggleAddModal}>
              <Icon className="fa-solid fa-plus me-2" size="12px" />
              Add {text}
            </DropdownItem>
          )}
          <DropdownItem onClick={toggleModal}>
            <Icon className="fa-solid fa-pencil me-2" size="12px" />
            Edit {text} Name
          </DropdownItem>
          {text == "Room" && (
            <>
              <DropdownItem onClick={toggleDeleteConfirmationState}>
                <Icon className="fa-regular fa-trash-can me-2" size="12px" />
                Delete {text}
              </DropdownItem>
              <DropdownItem onClick={toggleCloneConfirmationState}>
                <Icon className="fa-regular fa-clone me-2" size="12px" />
                Duplicate Room
              </DropdownItem>
            </>
          )}
        </DropdownMenu>
      </Dropdown>

      <ConfirmationModal
        isOpen={deleteConfirmationOpen}
        toggle={toggleDeleteConfirmationState}
        onConfirm={() => {
          onDelete(id, roomId || groupId);
          setDeleteConfirmationOpen(false);
        }}
        title={`Confirm ${text} Deletion`}
        message={`Are you sure you want to delete this ${text.toLowerCase()}?`}
        headingText="Confirm Deletion"
      />

      <ConfirmationModal
        isOpen={cloneConfirmationOpen}
        toggle={toggleCloneConfirmationState}
        onConfirm={() => {
          doCloneRoom();
          setCloneConfirmationOpen(false);
        }}
        message={`Are you sure you want to duplicate this room?`}
        headingText="Confirmation"
      />
    </div>
  );
};

export default ProjectDropDown;
